import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import api from "../../Axios";
import Swal from "sweetalert2";

const UpdatePartner = () => {
  const history = useHistory();
  const { id } = useParams();

  const [data, setData] = useState({
    height: "",
    age: "",
    maritalStatus: "",
    motherTongue: "",
    physicalStatus: "",
    eatingHabits: "",
    drinkingHabits: "",
    smokingHabits: "",
    familyStatus: "",
    religion: "",
    caste: "",
    subcaste: "",
    dhosam: "",
    star: "",
    education: "",
    employedIn: "",
    occupation: "",
    annualIncome: "",
    locationCountry: "",
  });

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      userId: Number(id),
      ...data,
    };

    api
      .post("/admin/userProfile/updatePartnerDetails", payload)
      .then(() => {
        Swal.fire("Success", "Partner details updated", "success").then(() => {
          history.goBack();
        });
      })
      .catch(() => {
        Swal.fire("Error", "Failed to update partner details", "error");
      });
  };

  useEffect(() => {
    api
      .get(`/admin/userProfile/profileView?userId=${id}`)
      .then((res) => {
        const d = res.data && res.data.data ? res.data.data.preference : {};
        setData({
          height: d.height || "",
          age: d.age || "",
          maritalStatus: d.maritalStatus || "",
          motherTongue: d.motherTongue || "",
          physicalStatus: d.physicalStatus || "",
          eatingHabits: d.eatingHabits || "",
          drinkingHabits: d.drinkingHabits || "",
          smokingHabits: d.smokingHabits || "",
          familyStatus: d.familyStatus || "",
          religion: d.religion || "",
          caste: d.caste || "",
          subcaste: d.subcaste || "",
          dhosam: d.dhosam || "",
          star: d.star || "",
          education: d.education || "",
          employedIn: d.employedIn || "",
          occupation: d.occupation || "",
          annualIncome: d.annualIncome || "",
          locationCountry: d.locationCountry || "",
        });
      })
      .catch(() => {
        Swal.fire("Error", "Failed to load partner details", "error");
      });
  }, [id]);

  return (
    <div className="content mt-5">
      <Row>
        <Col xs={12} md={12}>
          <div className="page-title mt-5">
            <div className="float-left">
              <h1 className="title">Update Partner Preferences</h1>
            </div>
          </div>

          <div className="col-12">
            <section className="box">
              <div className="content-body">
                <Form onSubmit={handleSubmit}>
                  <Box sx={{ minWidth: 120 }}>
                    {Object.keys(data).map((key) => (
                      <FormGroup key={key}>
                        <Label>{key.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase())}</Label>
                        <Input
                          type="text"
                          name={key}
                          value={data[key]}
                          onChange={handleChange}
                          placeholder={`Enter ${key}`}
                        />
                      </FormGroup>
                    ))}
                    <Button style={{ background: "black", color: "white" }}>
                      Submit
                    </Button>
                  </Box>
                </Form>
              </div>
            </section>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default UpdatePartner;
